import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getEtazhiBlackFridayPromoOffers } from 'shared/actions/etazhiBlackFriday';
import {
  selectEtazhiBlackFridayPromoOffers,
  selectIsEtazhiBlackFridayFilterEnabled,
} from 'shared/selectors/etazhiBlackFriday';

import type { TThunkDispatch } from 'shared/types/redux';

export function useGetPromoOffers(isPromoOffersVisible: boolean) {
  const dispatch = useDispatch<TThunkDispatch>();
  const isBlackFridayFilterEnabled = useSelector(selectIsEtazhiBlackFridayFilterEnabled);
  const promoOffers = useSelector(selectEtazhiBlackFridayPromoOffers);
  const [isFetched, setIsFetched] = React.useState(false);

  React.useEffect(() => {
    if (isFetched) {
      return;
    }

    if (isBlackFridayFilterEnabled || !isPromoOffersVisible) {
      setIsFetched(true);

      return;
    }

    dispatch(getEtazhiBlackFridayPromoOffers()).then(() => {
      setIsFetched(true);
    });
  }, [dispatch, isBlackFridayFilterEnabled, isPromoOffersVisible, isFetched]);

  return { isFetched, hasData: !!promoOffers?.length };
}
